// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_BucketModalShell_modal__KgKOf .SkyPortalModal__footer .MuiGrid-root {
  width: 100%;
  justify-content: stretch !important;
  padding-bottom: 4px !important;
  margin-left: 0 !important;
}

.storage_BucketModalShell_modal__KgKOf .SkyPortalModal__footer .MuiGrid-item {
  width: 100%;
  padding-right: 8px !important;
}

.storage_BucketModalShell_modal__KgKOf .SkyPortalModal__footer {
  border-top: none !important;
}

.storage_BucketModalShell_modal__KgKOf .SkyPortalModal__header {
  padding: 16px 8px 0 16px !important;
  border-bottom: none !important;
}

.storage_BucketModalShell_modal__KgKOf .SkyPortalModal__icon-box.MuiGrid-item {
  padding: 0 !important;
}

.storage_BucketModalShell_modal__KgKOf .SkyPortalModal__header .MuiGrid-item {
  padding-top: 0 !important;
}

.storage_BucketModalShell_modal__KgKOf .SkyPortalModal__header .MuiGrid-root {
  margin-top: 0 !important;
}

.storage_BucketModalShell_controls__yknJY {
  display: flex;
  width: 100%;
  gap: 12px;
}

.storage_BucketModalShell_body__v\\+e5O {
  padding: 8px;
}

.storage_BucketModalShell_form__GEkUs {
  display: flex;
  flex-direction: column;
  padding: 8px !important;
  gap: 32px;
}

.storage_BucketModalShell_field__pa0Xs {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/containers/BucketsPageContent/modals/BucketModalShell/BucketModalShell.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mCAAmC;EACnC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".modal :global(.SkyPortalModal__footer .MuiGrid-root) {\n  width: 100%;\n  justify-content: stretch !important;\n  padding-bottom: 4px !important;\n  margin-left: 0 !important;\n}\n\n.modal :global(.SkyPortalModal__footer .MuiGrid-item) {\n  width: 100%;\n  padding-right: 8px !important;\n}\n\n.modal :global(.SkyPortalModal__footer) {\n  border-top: none !important;\n}\n\n.modal :global(.SkyPortalModal__header) {\n  padding: 16px 8px 0 16px !important;\n  border-bottom: none !important;\n}\n\n.modal :global(.SkyPortalModal__icon-box.MuiGrid-item) {\n  padding: 0 !important;\n}\n\n.modal :global(.SkyPortalModal__header .MuiGrid-item) {\n  padding-top: 0 !important;\n}\n\n.modal :global(.SkyPortalModal__header .MuiGrid-root) {\n  margin-top: 0 !important;\n}\n\n.controls {\n  display: flex;\n  width: 100%;\n  gap: 12px;\n}\n\n.body {\n  padding: 8px;\n}\n\n.form {\n  display: flex;\n  flex-direction: column;\n  padding: 8px !important;\n  gap: 32px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `storage_BucketModalShell_modal__KgKOf`,
	"controls": `storage_BucketModalShell_controls__yknJY`,
	"body": `storage_BucketModalShell_body__v+e5O`,
	"form": `storage_BucketModalShell_form__GEkUs`,
	"field": `storage_BucketModalShell_field__pa0Xs`
};
export default ___CSS_LOADER_EXPORT___;
